import { get } from './method';
import routes from '@configs/routes.json';
import { IBuild } from '../models/build';

export const getBuilds = (): Promise<IBuild[]> => {
  return get(routes.api.assets.builds).then((resp) => resp.json());
};
